import React, { useState } from "react";
import DetailsItem from "../Details/DetailsItem";
import { apiShape, notifierShape, withApi, withNotifier } from "../../context";

// FIXME do it the right way, when the hub offers the needed endpoints/filters
const softwareTypeFirmwareId = 1;

type Props = {
  asset: {
    id?: number;
  };
  api: apiShape;
  notifier: notifierShape;
};

export function AssetFirmwareVersion({ asset, api, notifier }: Props) {
  const [firmwareVersion, setFirmwareVersion] = useState();

  React.useEffect(() => {
    const loadData = async () => {
      try {
        const response = await api.getAll(`/assets/${asset.id}/softwares`);
        const firmware = response.softwares?.find(
          (software: $TSFixMe) =>
            software.software_type.id === softwareTypeFirmwareId,
        );
        if (firmware) {
          setFirmwareVersion(firmware.version_number);
        }
      } catch (e) {
        notifier.showError(api.translateError(e));
      }
    };

    loadData();
  }, [asset.id]);

  return firmwareVersion ? (
    <DetailsItem
      translationKey="label.firmware_version"
      value={firmwareVersion}
    />
  ) : null;
}

export default withApi(withNotifier(AssetFirmwareVersion));
